import { Button, Flex } from "antd";
import styled from "styled-components";

export const StyledCamera = styled.div`
    position: fixed;
    inset: 0;
    z-index: 500;
    display: flex;
    background: ${({ theme }) => `${theme.colors.black}E6`};
`;

export const StyledViewContainer = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

export const StyledCapturedImage = styled.img`
    object-fit: contain;
    width: 100%;
    height: 100%;
`;

export const StyledLoadingContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

type ActionsPlacement = "top" | "bottom";

export const StyledActionsContainer = styled(Flex)<{
    $placement?: ActionsPlacement;
    $offset?: number;
}>`
    position: absolute;
    z-index: 2;

    ${({ $placement = "bottom", $offset = 8 }) =>
        $placement === "top"
            ? `
        top: ${$offset}px;
        bottom: auto;
    `
            : `
        bottom: ${$offset}px;
        top: auto;
    `}

    padding: 12px 24px;
    background: ${({ theme }) => `${theme.colors.black}80`};
    border-radius: 32px;

    left: 50%;
    transform: translateX(-50%);
`;

export const StyledTextButton = styled(Button)`
    color: ${({ theme }) => theme.colors.white};

    &:hover {
        color: ${({ theme }) => theme.colors.white} !important;
        opacity: 0.8;
    }
`;

export const StyledCameraButton = styled(Button)<{ $disabled: boolean }>`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0;
    border: 2px solid white;
    background: transparent;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    transition: all 0.2s;
    opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};

    &:hover {
        opacity: 0.8;
    }

    &::before {
        content: "";
        position: absolute;
        inset: 4px;
        border-radius: 50%;
        background: white;
        transition: all 0.2s;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;
